var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "root", staticClass: "hkl-table" },
    [
      _c(
        "a-table",
        _vm._g(
          _vm._b(
            {
              ref: "table",
              attrs: {
                columns: _vm.tableColumns,
                "data-source": _vm.sortedList,
                filtered: false,
                pagination: false,
                rowKey: function (record, index) {
                  return index
                },
              },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.columns, function (column, j) {
                    return {
                      key: column.dataIndex,
                      fn: function (text, record, index) {
                        return [
                          _c(
                            _vm.getItemComponentName(record, column, index),
                            _vm._g(
                              _vm._b(
                                {
                                  key: _vm.getItemComponentKey(record, j),
                                  tag: "component",
                                },
                                "component",
                                _vm.getItemComponentAttrs(
                                  record,
                                  column,
                                  index
                                ),
                                false
                              ),
                              _vm.getItemComponentListeners(
                                record,
                                column,
                                index
                              )
                            ),
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(record[column.dataIndex]) +
                                  "\n      "
                              ),
                            ]
                          ),
                        ]
                      },
                    }
                  }),
                ],
                null,
                true
              ),
            },
            "a-table",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm._l(_vm.columns, function (column, i) {
            return _c("template", { slot: "title-" + column.dataIndex }, [
              _c(
                "div",
                {
                  key: "title-" + i,
                  staticClass: "hkl-table__header-title",
                  class: { pointer: !column.disabledSorter },
                  on: {
                    click: function () {
                      return _vm.updateSorter(column)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        column.titleRaw === true || !_vm.$te(column.title)
                          ? column.title
                          : _vm.$t(column.title)
                      ) +
                      "\n        "
                  ),
                  Array.isArray(_vm.sortObject) &&
                  _vm.sortObject.length &&
                  column.dataIndex === _vm.sortObject[0]
                    ? _c("i", { key: i, class: _vm.sortIconClasses })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.filterBar
                ? _c(
                    "div",
                    {
                      key: "filter-" + i,
                      staticClass: "hkl-table__header-filter",
                    },
                    [
                      _c(
                        _vm.getFilterComponentName(column),
                        _vm._b(
                          {
                            tag: "component",
                            model: {
                              value: _vm.queryObject[column.dataIndex],
                              callback: function ($$v) {
                                _vm.$set(_vm.queryObject, column.dataIndex, $$v)
                              },
                              expression: "queryObject[column.dataIndex]",
                            },
                          },
                          "component",
                          _vm.getFilterComponentAttrs(column),
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "HKLLoadMore",
        _vm._g({ attrs: { watchElement: _vm.$refs.root } }, _vm.$listeners)
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }